import axios from 'axios'

export const createContactAddressCompanyUsers = async () => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL}/contactAddress/companyUsers`,
    {},
    {
      withCredentials: true,
    },
  )
}
